import i18next from 'i18next'
import BaseItem from './BaseItem'

export default class MenuItem extends BaseItem {

	/** @type string */ description
	/** Any of {@link MenuItem.STATUS}
	 * @type 'shown'|'hidden'|'unavailable' */ shown_status
	/** @type boolean */ single_price
	/** @type ?string */ image
	/** See description of {@link category}
	 * @type number */ category_id
	/** Shows only in the Item Edit page (data coming from /item/$id). List of IDs this item belongs to.
	 * @type number[] */ category_ids
	/** @type number[] */ icon_ids
	/** @type object[] */ menu_prices //TODO write a typedef or a whole new model object
	/** @type ?number */ shown_prices_count

	/**
	 * Key of constants: status "slugs"
	 * @return {{ SHOWN: 'shown', UNAVAILABLE: 'unavailable', HIDDEN: 'hidden' }}
	 */
	static get STATUS() {
		return Object.freeze({
			SHOWN      : 'shown',
			UNAVAILABLE: 'unavailable',
			HIDDEN     : 'hidden',
		})
	}
	/**
	 * @return {Object<{ icon: string, className: string, text: string }>}
	 */
	static get STATUS_UI() {
		return {
			[MenuItem.STATUS.SHOWN]      : { icon:'eye',           className: 'text-success', text: i18next.t('Shown') },
			[MenuItem.STATUS.HIDDEN]     : { icon:'eye-slash',     className: 'text-danger',  text: i18next.t('Hidden') },
			[MenuItem.STATUS.UNAVAILABLE]: { icon:'minus-octagon', className: 'text-warning', text: i18next.t('Unavailable') }
		}
	}

	/**
	 * Uses the React "hack" to turn <br> into an actual line break
	 * @return {JSX.Element}
	 */
	get description_with_HTML() {
		return <span dangerouslySetInnerHTML={{ __html: this.description }}/>
	}
}
